// „Meine Geräte“ (15.10.2026) – Erklärung in sections/rxk-geraete.liquid.
// Sammlung: <rxk-geraete> zeichnet die Leiste und blendet unpassende Karten aus.
// Produktseite: wählt das gemerkte Gerät in der Modell-Option vor (ohne ?variant=).
(() => {
  const SKRIPT = document.currentScript;
  const KEY = 'rxk-geraete', GAST = 'rxk-geraete-gast', AUS = 'rxk-geraete-aus', FRAGE = 'rxk-geraete-frage', HINWEIS = 'rxk-geraete-hinweis';
  const GRUPPEN = { iphone: 'iPhone', mac: 'MacBook', ipad: 'iPad', imac: 'iMac' };
  // Geräte ohne Warteliste (29.10.2026, Andreas: „iPhone Duo Warteliste weg … Cases kommen auch noch, aber keine Liste mehr“)
  const OHNE_WL = ['iPhone Duo'];
  const gruppe = (m) => (/^iPhone/i.test(m) ? 'iphone' : /^MacBook/i.test(m) ? 'mac' : /^iPad/i.test(m) ? 'ipad' : /^iMac/i.test(m) ? 'imac' : '');
  const lesen = (s, k) => { try { return JSON.parse(s.getItem(k)); } catch { return null; } };
  const istGast = () => !!lesen(sessionStorage, GAST);
  const istAus = () => sessionStorage.getItem(AUS) === '1';
  const laden = () => {
    const d = (istGast() ? lesen(sessionStorage, GAST) : lesen(localStorage, KEY)) || {};
    return { geraete: Array.isArray(d.geraete) ? d.geraete : [], aktiv: d.aktiv && typeof d.aktiv === 'object' ? d.aktiv : {} };
  };
  const speichern = (z) => {
    try { (istGast() ? sessionStorage : localStorage).setItem(istGast() ? GAST : KEY, JSON.stringify({ ...z, t: Date.now() })); } catch {} // t: Ablauf siehe layout/theme.liquid
  };
  const aktiveGeraete = () => (istAus() ? {} : laden().aktiv);
  const slug = (m) => m.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; };

  // Geräte-Finder nachladen und einbetten: Abschnitt der Finder-Seite per Section Rendering API, Skript/CSS einmal
  const finderEinbetten = async (url, ziel) => {
    // Ganze Finder-Seite holen (section_id bräuchte bei Vorlagen-Abschnitten die interne ID) und den Finder herauslösen
    const r = await fetch(new URL(url, location.origin)); if (!r.ok) throw new Error('finder');
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const tpl = { content: doc.querySelector('rxk-geraete-finder')?.closest('.shopify-section') || doc.body };
    const f = tpl.content.querySelector('rxk-geraete-finder'); if (!f) throw new Error('finder');
    for (const l of tpl.content.querySelectorAll('link[rel="stylesheet"]')) if (!document.querySelector('link[href="' + l.getAttribute('href') + '"]')) document.head.append(l.cloneNode());
    for (const s of tpl.content.querySelectorAll('style')) ziel.append(s.cloneNode(true));
    f.dataset.modus = 'eingebettet';
    ziel.append(document.importNode(f, true));
    const s = tpl.content.querySelector('script[src*="rxk-geraete-finder"]');
    if (s && !customElements.get('rxk-geraete-finder') && !document.querySelector('script[data-rxk-gf]')) { const n = document.createElement('script'); n.src = s.getAttribute('src'); n.dataset.rxkGf = '1'; document.head.append(n); }
    return ziel.querySelector('rxk-geraete-finder');
  };

  // Bildschirm in CSS-Pixeln (hochkant) -> mögliche iPhones, neueste zuerst. Nur ein Vorschlag.
  const BILDSCHIRM = {
    '440x956': ['iPhone 18 Pro Max', 'iPhone 17 Pro Max', 'iPhone 16 Pro Max'],
    '402x874': ['iPhone 18 Pro', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 16 Pro'],
    '420x912': ['iPhone Air'],
    '430x932': ['iPhone 16 Plus', 'iPhone 15 Pro Max', 'iPhone 15 Plus', 'iPhone 14 Pro Max'],
    '393x852': ['iPhone 16', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 14 Pro'],
    '390x844': ['iPhone 17e', 'iPhone 16e', 'iPhone 14', 'iPhone 13 Pro', 'iPhone 13'],
    '428x926': ['iPhone 14 Plus', 'iPhone 13 Pro Max'],
    '375x812': ['iPhone 13 Mini'],
  };

  class RxkGeraete extends HTMLElement {
    connectedCallback() {
      const d = JSON.parse(this.querySelector('[data-rxk-gr-daten]').textContent);
      this.produkte = d.produkte || {};
      this.alle = d.alle || {};
      this.bald = (d.bald || []).map((b) => b.trim()).filter(Boolean);
      this.oben = (d.oben || []).map((b) => b.trim()).filter(Boolean);
      this.t = d.texte || {};
      this.modelle = [...new Set(Object.values(this.produkte).flatMap((w) => (w ? w.split('|') : [])))];
      // Shop-weit bekannt (JSON-Insel „alle“ = collections.all): Ein Modell, das irgendwo im Shop ein
      // Produkt hat, ist regulär – auch in einer Sammlung ohne Treffer (20.10.2026: iPhone Duo hat mit
      // dem Fusion Snap sein erstes Produkt, soll nirgends mehr „bald“ heißen). Vorher stand hier
      // this.modelle vor seiner Zuweisung, darum landete „oben“ immer in „bald“.
      this.bekannt = new Set([...this.modelle, ...Object.values(this.alle).flatMap((w) => (w ? w.split('|') : []))]);
      for (const m of this.oben) if (!this.bekannt.has(m) && !this.bald.includes(m)) this.bald.push(m);
      this.kompakt();
      this.neu();
      this.ausrichten();
      // Raster und Filterzeile werden von Horizon beim Filtern/Nachladen ersetzt -> breit beobachten
      const bereich = document.querySelector('results-list') || document.querySelector('main');
      if (bereich) new MutationObserver(() => { this.filtern(); this.knopfEinsetzen(); }).observe(bereich, { childList: true, subtree: true });
      this.vorschlagen();
    }

    // Eine Leiste (16.10.2026, Andreas): Geräte-Knopf als erstes Element der Kategoriezeile,
    // Auswahl im Fenster (Handy: Schublade von unten, Desktop: mittig). Vorher eigene Zeile + Steinfilter.
    kompakt() {
      const t = this.t;
      const sheet = document.createElement('dialog');
      sheet.className = 'rxk-gr__sheet';
      const kopf = el('div', 'rxk-gr__sheet-kopf');
      kopf.append(el('p', 'rxk-gr__frage', t.frage));
      const fertig = el('button', 'rxk-gr__fertig', t.fertig);
      fertig.type = 'button';
      fertig.addEventListener('click', () => sheet.close());
      kopf.append(fertig);
      sheet.append(kopf);
      for (const c of [...this.children]) if (!c.matches('script')) sheet.append(c);
      sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
      this.append(sheet);
      this.sheet = sheet;
      this.knopf = el('button', 'rxk-gr__knopf');
      this.knopf.type = 'button';
      this.knopf.addEventListener('click', () => sheet.showModal());
      this.knopfEinsetzen();
      if (this.querySelector('[data-rxk-gr-danke], .rxk-gr__wl-fehler')) setTimeout(() => sheet.showModal(), 300);
      const fl = sheet.querySelector('.rxk-gr__finder');
      if (fl) {
        const zurueck = () => { sheet.classList.remove('zeigt-finder'); sheet.querySelector('.rxk-gr__gf')?.remove(); };
        fl.addEventListener('click', async (e) => {
          e.preventDefault();
          zurueck();
          const box = el('div', 'rxk-gr__gf'); sheet.append(box); sheet.classList.add('zeigt-finder');
          try { await finderEinbetten(fl.href, box); } catch { location.href = fl.href; }
        });
        sheet.addEventListener('rxk-gf:gewaehlt', () => { zurueck(); sessionStorage.removeItem(AUS); this.neu(); sheet.close(); });
        sheet.addEventListener('close', zurueck);
      }
    }

    knopfEinsetzen() {
      if (!this.knopf || this.knopf.isConnected) return;
      // Shop Editorial (23.10.2026): eigener Platz in dessen Leiste
      const platz = document.querySelector('[data-rxk-gr-platz]');
      if (platz) { platz.append(this.knopf); return; }
      const kat = document.querySelector('.rxk-kat__liste');
      if (kat) {
        const li = el('li', 'rxk-kat__geraet');
        li.append(this.knopf);
        kat.prepend(li);
        return;
      }
      const filter = document.querySelector('.facets-toggle__wrapper');
      if (filter) filter.append(this.knopf);
      else this.prepend(this.knopf);
    }

    // Knopf steht fest links (CSS sticky); aktive Kategorie gleich rechts daneben ins Bild holen.
    // Erst nach dem Zeichnen (Knopftext, Zahlen, ausgeblendete Kategorien ändern die Breiten).
    ausrichten() {
      const li = document.querySelector('.rxk-kat__geraet'), nav = li?.closest('.rxk-kat__nav');
      if (!nav) return;
      // Einrasten (scroll-snap) rechts neben dem Knopf statt am Rand darunter
      nav.style.scrollPaddingInlineStart = `${Math.round(li.getBoundingClientRect().width) + 16}px`;
      nav.scrollLeft = 0;
      const ak = nav.querySelector('.ist-aktiv'), r = nav.getBoundingClientRect();
      if (ak && ak.getBoundingClientRect().right > r.right - 40) nav.scrollLeft += ak.getBoundingClientRect().left - li.getBoundingClientRect().right - 24;
      nav.dispatchEvent(new Event('scroll'));
    }

    schliessenWennFertig() {
      if (this.sheet && this.sheet.open && !this.ohne) this.sheet.close();
    }

    knopfText() {
      if (!this.knopf) return;
      const a = Object.values(aktiveGeraete()).filter(Boolean);
      const geraet = a.length ? (a.length > 1 ? `${a[0]} +${a.length - 1}` : a[0]) : '';
      const text = geraet || (this.vorschlagOffen ? this.t.knopf_frage : this.t.waehlen);
      if (this.knopf.dataset.text !== text) {
        this.knopf.dataset.text = text;
        const symbol = el('span', 'rxk-gr__knopf-symbol');
        symbol.setAttribute('aria-hidden', 'true');
        this.knopf.replaceChildren(symbol, el('span', 'rxk-gr__knopf-text', text));
        if (geraet) {
          // × am Knopf: Filter für diese Sitzung aus (wie „Alle anzeigen“), Geräte bleiben gemerkt
          const x = el('span', 'rxk-gr__knopf-x', '×');
          x.setAttribute('role', 'button');
          x.setAttribute('aria-label', this.t.alle);
          x.addEventListener('click', (e) => { e.stopPropagation(); sessionStorage.setItem(AUS, '1'); this.neu(); });
          this.knopf.append(x);
        }
      }
      this.knopf.classList.toggle('hat-auswahl', a.length > 0);
      this.knopf.classList.toggle('rxk-gr__knopf--punkt', !a.length && !!this.vorschlagOffen);
      this.knopf.setAttribute('aria-label', `${this.t.frage} ${text}`);
    }

    neu() { this.zeichnen(); this.filtern(); }

    waehlen(m) {
      const z = laden();
      if (!z.geraete.includes(m)) z.geraete.push(m);
      z.aktiv[gruppe(m)] = m;
      sessionStorage.removeItem(AUS);
      speichern(z);
      this.neu();
    }

    zeichnen() {
      const z = laden(), aus = istAus(), t = this.t;
      const box = this.querySelector('[data-rxk-gr-chips]');
      box.replaceChildren();
      for (const g of z.geraete) {
        const chip = el('button', 'rxk-gr__chip');
        chip.type = 'button';
        chip.setAttribute('aria-pressed', String(!aus && z.aktiv[gruppe(g)] === g));
        chip.append(g);
        if (!this.bekannt.has(g) && this.bald.includes(g)) chip.append(el('span', 'rxk-gr__bald', t.bald));
        const x = el('span', 'rxk-gr__chip-x', '×');
        x.setAttribute('role', 'button');
        x.setAttribute('aria-label', `${g} ${t.entfernen}`);
        x.addEventListener('click', (e) => {
          e.stopPropagation();
          const zz = laden();
          zz.geraete = zz.geraete.filter((m) => m !== g);
          if (zz.aktiv[gruppe(g)] === g) zz.aktiv[gruppe(g)] = null;
          speichern(zz);
          this.neu();
        });
        chip.append(x);
        chip.addEventListener('click', () => {
          const zz = laden(), gr = gruppe(g);
          zz.aktiv[gr] = !istAus() && zz.aktiv[gr] === g ? null : g;
          sessionStorage.removeItem(AUS);
          speichern(zz);
          this.neu();
        });
        box.append(chip);
      }
      // Auswahl: Modelle dieser Seite nach Gruppe, dazu die „bald“-Modelle
      const sel = el('select', 'rxk-gr__select');
      sel.setAttribute('aria-label', t.waehlen);
      sel.append(new Option(z.geraete.length ? t.hinzu : t.waehlen, ''));
      // „Ganz oben“ (z. B. iPhone Duo): Hat das Modell im Shop schon ein Produkt, steht es als erster
      // Eintrag seiner Gruppe (Andreas 20.10.: „bei den iPhones einsortieren, ist ja eins“); sonst
      // vor allen Gruppen in „Bald“.
      const oben = this.oben.filter((m) => !z.geraete.includes(m));
      const obenRegulaer = oben.filter((m) => this.bekannt.has(m));
      const obenBald = oben.filter((m) => !this.bekannt.has(m));
      if (obenBald.length) {
        const og = document.createElement('optgroup');
        og.label = (t.bald || '').charAt(0).toUpperCase() + (t.bald || '').slice(1);
        for (const m of obenBald) og.append(new Option(`${m} – ${t.bald}`, m));
        sel.append(og);
      }
      for (const [gr, name] of Object.entries(GRUPPEN)) {
        const liste = [...obenRegulaer.filter((m) => gruppe(m) === gr), ...this.modelle.filter((m) => gruppe(m) === gr), ...this.bald.filter((m) => gruppe(m) === gr && !this.modelle.includes(m))]
          .filter((m, i, a) => !z.geraete.includes(m) && !obenBald.includes(m) && a.indexOf(m) === i);
        if (!liste.length) continue;
        const og = document.createElement('optgroup');
        og.label = name;
        for (const m of liste) og.append(new Option(this.bekannt.has(m) ? m : `${m} – ${t.bald}`, m));
        sel.append(og);
      }
      sel.addEventListener('change', () => { if (sel.value) { this.waehlen(sel.value); this.schliessenWennFertig(); } });
      box.append(sel);
      if (z.geraete.length) {
        const alle = el('button', 'rxk-gr__chip rxk-gr__chip--leise', t.alle);
        alle.type = 'button';
        alle.setAttribute('aria-pressed', String(aus));
        alle.addEventListener('click', () => { sessionStorage.setItem(AUS, '1'); this.neu(); });
        box.append(alle);
      }
      const gast = el('button', 'rxk-gr__link', istGast() ? t.gast_ende : t.gast);
      gast.type = 'button';
      gast.addEventListener('click', () => {
        if (istGast()) sessionStorage.removeItem(GAST);
        else sessionStorage.setItem(GAST, JSON.stringify({ geraete: [], aktiv: {} }));
        sessionStorage.removeItem(AUS);
        this.neu();
      });
      box.append(gast);
    }

    // Streng (15.10.2026, Andreas: „bei iPhone 18 Pro zeigt er dennoch viele andere Produkte“):
    // Ist ein Gerät aktiv, bleibt nur, was zu einem der aktiven Geräte passt –
    // geräteunabhängige Produkte (AirTag, Uhren, Ständer) erst wieder über „Alle anzeigen“.
    // Filtert nur innerhalb der Geräteart (25.10.2026, Andreas: „ja super“): Ein gemerktes iPhone blendet nur
    // Hüllen für andere iPhones aus. Produkte ohne Gerät (Marble Base, AirTag, Watch, Stands, Geschenkkarte) und
    // Produkte einer anderen Art (MacBook-/iPad-Skins) bleiben sichtbar. Vorher fiel alles ohne Treffer raus.
    passt(w, aktiv) {
      const liste = Object.values(aktiv).filter(Boolean);
      if (!liste.length || !w) return true;
      const ms = w.split('|');
      const arten = new Set(ms.map(gruppe));
      const relevant = liste.filter((m) => arten.has(gruppe(m)));
      return !relevant.length || relevant.some((m) => ms.includes(m));
    }

    filtern() {
      const aktiv = aktiveGeraete(), t = this.t;
      const liste = Object.values(aktiv).filter(Boolean);
      let n = 0;
      for (const w of Object.values(this.produkte)) if (this.passt(w, aktiv)) n++;
      for (const li of document.querySelectorAll('.product-grid__item[data-product-id], [data-rxk-gr-karte][data-product-id]')) {
        const w = this.produkte[li.dataset.productId];
        const raus = w !== undefined && !this.passt(w, aktiv);
        if (li.classList.contains('rxk-gr-aus') !== raus) li.classList.toggle('rxk-gr-aus', raus);
      }
      const status = this.querySelector('[data-rxk-gr-status]');
      const teile = [];
      if (istGast()) teile.push(t.gast_aktiv);
      if (liste.length) teile.push(t.passt.replace('__G__', liste.join(' · ')).replace('__N__', n));
      // Nur bei Änderung schreiben: ohne results-list (Shop Editorial) beobachtet der MutationObserver ganz main –
      // jedes Neuschreiben löste sonst filtern() erneut aus (Endlosschleife, 23.10.2026)
      const stText = teile.join(' · ');
      if (status.textContent !== stText) status.textContent = stText;
      if (status.hidden !== !teile.length) status.hidden = !teile.length;
      // Warteliste: aktives Gerät ohne ein einziges passendes Produkt hier
      const ohne = liste.find((m) => !Object.values(this.produkte).some((w) => w && w.split('|').includes(m)));
      this.ohne = ohne;
      this.knopfText();
      this.kategorienZaehlen(aktiv);
      this.hinweis(liste, n);
      // Shop Editorial hört mit (Variantenlinks, Kapitelzahlen, Index) – nur bei echter Änderung
      const sig = JSON.stringify(aktiv);
      if (sig !== this.ereignisSig) { this.ereignisSig = sig; document.dispatchEvent(new CustomEvent('rxk-geraete:wechsel', { detail: { aktiv: liste } })); }
      const wl = this.querySelector('[data-rxk-gr-wl]');
      const wlGeraet = ohne && !OHNE_WL.includes(ohne) ? ohne : null;
      if (wl) {
        if (wl.hidden !== !wlGeraet) wl.hidden = !wlGeraet;
        if (wlGeraet) {
          const wlT = this.querySelector('[data-rxk-gr-wl-text]'), wlText = `${t.keine.replace('__G__', wlGeraet)} ${t.wl_text.replace('__G__', wlGeraet)}`;
          if (wlT.textContent !== wlText) wlT.textContent = wlText;
          this.querySelector('[data-rxk-gr-tags]').value = `newsletter,warteliste-geraet,geraet-${slug(wlGeraet)}`;
        }
      }
    }

    // Zahlen an den Kategorie-Chips: wie viele Produkte je Kategorie zum Gerät passen.
    // Leere Kategorien verschwinden (16.10.: vorher nur blass), die aktuelle bleibt immer sichtbar.
    // Ohne Gerät alles wie gehabt.
    kategorienZaehlen(aktiv) {
      const an = Object.values(aktiv).some(Boolean);
      const sig = JSON.stringify(aktiv);
      if (sig === this.katSig) return;
      this.katSig = sig;
      for (const li of document.querySelectorAll('.rxk-kat__liste > li[data-rxk-ids]')) {
        const a = li.querySelector('.rxk-kat__link');
        a.querySelector('.rxk-kat__zahl')?.remove();
        li.classList.remove('ist-leer');
        if (!an) continue;
        const n = li.dataset.rxkIds.split(',').filter((id) => id && this.passt(this.alle[id] || '', aktiv)).length;
        // Aktiver Chip zeigt „9 von 24“, damit niemand glaubt, der Shop habe nur 9 Produkte (25.10.2026)
        const gesamt = li.dataset.rxkIds.split(',').filter(Boolean).length;
        a.append(el('span', 'rxk-kat__zahl', a.classList.contains('ist-aktiv') && n < gesamt ? `${n} ${this.t.von || 'von'} ${gesamt}` : String(n)));
        if (!n) li.classList.add('ist-leer');
      }
    }

    // Neuer Besuch mit gemerktem Gerät (25.10.2026, Andreas: Kunde sucht am nächsten Tag ein anderes Gerät
    // und sieht es nicht): einmal je Besuch eine Zeile unter der Leiste „Gefiltert für … · n weitere ausgeblendet · Alle anzeigen“.
    hinweis(liste, n) {
      const versteckt = Object.keys(this.produkte).length - n;
      if (!this.hinweisEl) {
        if (!liste.length || versteckt <= 0 || istGast() || sessionStorage.getItem(HINWEIS)) return;
        try { sessionStorage.setItem(HINWEIS, '1'); } catch {}
        const p = el('p', 'rxk-gr-hinweis');
        p.setAttribute('role', 'status');
        const text = el('span');
        const alle = el('button', '', this.t.alle); alle.type = 'button';
        alle.addEventListener('click', () => { try { sessionStorage.setItem(AUS, '1'); } catch {} this.hinweisEl?.remove(); this.neu(); });
        const zu = el('button', 'rxk-gr-hinweis__zu', '×'); zu.type = 'button'; zu.setAttribute('aria-label', this.t.fertig || '×');
        zu.addEventListener('click', () => this.hinweisEl?.remove());
        p.append(text, alle, zu);
        // In die Kategorie-Leiste (Seitenraster, gleiche Kante wie die Chips); im Editorial unter dessen Leiste
        const kat = this.knopf?.closest('.rxk-kat');
        if (kat) kat.append(p); else (this.knopf?.closest('.rxk-ed__leiste') || this.knopf?.closest('ul') || this).after(p);
        this.hinweisEl = p;
      }
      if (!this.hinweisEl.isConnected) return;
      if (!liste.length || versteckt <= 0) { this.hinweisEl.remove(); return; }
      const t = this.t.hinweis_gefiltert.replace('__G__', liste.join(' · ')).replace('__N__', versteckt);
      const span = this.hinweisEl.firstChild; if (span.textContent !== t) span.textContent = t;
    }

    vorschlagen() {
      const box = this.querySelector('[data-rxk-gr-vorschlag]');
      if (laden().geraete.length || istGast() || localStorage.getItem(FRAGE) || !/iPhone/.test(navigator.userAgent)) return;
      const w = Math.min(screen.width, screen.height), h = Math.max(screen.width, screen.height);
      const kand = (BILDSCHIRM[`${w}x${h}`] || []).filter((m) => this.modelle.includes(m) || this.bald.includes(m));
      if (!kand.length) return;
      const fertig = () => { try { localStorage.setItem(FRAGE, '1'); } catch {} box.hidden = true; this.vorschlagOffen = false; this.knopfText(); };
      box.replaceChildren(el('p', '', this.t.vorschlag));
      const chips = el('div', 'rxk-gr__chips');
      for (const m of kand) {
        const c = el('button', 'rxk-gr__chip', m);
        c.type = 'button';
        c.addEventListener('click', () => { fertig(); this.waehlen(m); this.schliessenWennFertig(); });
        chips.append(c);
      }
      const nein = el('button', 'rxk-gr__link', this.t.nein);
      nein.type = 'button';
      nein.addEventListener('click', fertig);
      chips.append(nein);
      box.append(chips);
      box.hidden = false;
      this.vorschlagOffen = true;
      this.knopfText();
    }
  }
  if (!customElements.get('rxk-geraete')) customElements.define('rxk-geraete', RxkGeraete);

  // Produktseite: gemerktes Gerät vorwählen, wenn die Adresse keine Variante vorgibt.
  // Hinweis, wenn das Produkt Modelle der Gerätegruppe hat, aber nicht das gemerkte Gerät.
  const hinweisen = (picker, aktiv) => {
    picker.parentElement.querySelector('.rxk-gr-hinweis')?.remove();
    const werte = [...picker.querySelectorAll('input[type="radio"], select option')].map((x) => x.value).filter((v) => gruppe(v));
    const fehlt = aktiv.find((m) => werte.some((v) => gruppe(v) === gruppe(m)) && !werte.includes(m));
    if (!fehlt || !SKRIPT) return;
    const box = el('p', 'rxk-gr-hinweis', SKRIPT.dataset.nichtPassend.replace('__G__', fehlt) + ' ');
    const a = el('a', '', SKRIPT.dataset.passende);
    a.href = SKRIPT.dataset.alle || '/collections/all';
    box.append(a);
    box.style.cssText = 'margin:12px 0 0;padding:10px 12px;border:1px solid #111;font-size:13px;line-height:1.4';
    a.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:3px';
    picker.after(box);
  };
  const imPickerWaehlen = (picker, m) => {
    const r = picker.querySelector('input[type="radio"][value="' + CSS.escape(m) + '"]');
    if (r) { if (!r.checked && r.getAttribute('aria-disabled') !== 'true') r.click(); return true; }
    const o = [...picker.querySelectorAll('select option')].find((x) => x.value === m);
    if (o) { const s = o.closest('select'); if (s.value !== m) { s.value = m; s.dispatchEvent(new Event('change', { bubbles: true })); } return true; }
    return false;
  };
  const vorwaehlen = () => {
    const aktiv = Object.values(aktiveGeraete()).filter(Boolean);
    const picker = document.querySelector('variant-picker');
    if (!aktiv.length || !picker) return;
    hinweisen(picker, aktiv);
    if (/[?&]variant=/.test(location.search)) return;
    for (const m of aktiv) {
      const r = picker.querySelector(`input[type="radio"][value="${CSS.escape(m)}"]`);
      if (r) { if (!r.checked && r.getAttribute('aria-disabled') !== 'true') r.click(); return; }
      const o = [...picker.querySelectorAll('select option')].find((x) => x.value === m);
      if (o) {
        const s = o.closest('select');
        if (s.value !== m) { s.value = m; s.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
    }
  };
  // Produktseite: Link zum Geräte-Finder (22.10.2026), seit 23.10. rechts neben „Modell“, öffnet die Schublade.
  // Horizon zeichnet den variant-picker bei jeder Wahl neu → Link per Observer wieder einsetzen.
  const finderLink = () => {
    const picker = document.querySelector('variant-picker');
    if (!picker || !SKRIPT || !SKRIPT.dataset.finder) return;
    const werte = [...picker.querySelectorAll('input[type="radio"], select option')].map((x) => x.value).filter((v) => gruppe(v));
    if (!werte.length) return;
    const a = el('a', 'rxk-gr-finder', SKRIPT.dataset.finderLink + ' →');
    a.href = SKRIPT.dataset.finder + '?zurueck=' + encodeURIComponent(location.pathname);
    a.addEventListener('click', async (e) => {
      e.preventDefault();
      let d = document.querySelector('.rxk-gr__sheet--produkt');
      if (!d) {
        d = document.createElement('dialog'); d.className = 'rxk-gr__sheet rxk-gr__sheet--produkt zeigt-finder';
        const kopf = el('div', 'rxk-gr__sheet-kopf'); kopf.append(el('p', 'rxk-gr__frage', SKRIPT.dataset.finderLink));
        const zu = el('button', 'rxk-gr__fertig', '×'); zu.type = 'button'; zu.setAttribute('aria-label', 'Schließen'); zu.addEventListener('click', () => d.close()); kopf.append(zu);
        d.append(kopf); d.addEventListener('click', (ev) => { if (ev.target === d) d.close(); });
        d.addEventListener('close', () => d.querySelector('.rxk-gr__gf')?.remove());
        d.addEventListener('rxk-gf:gewaehlt', (ev) => { const pk = document.querySelector('variant-picker'); if (pk) { imPickerWaehlen(pk, ev.detail.modell); hinweisen(pk, Object.values(aktiveGeraete()).filter(Boolean)); } d.close(); });
        document.body.append(d);
      }
      const box = el('div', 'rxk-gr__gf'); d.append(box); d.showModal();
      try { await finderEinbetten(SKRIPT.dataset.finder, box); } catch { location.href = a.href; }
    });
    a.style.cssText = 'float:right;font-size:13px;font-weight:400;color:#111;text-decoration:underline;text-underline-offset:3px;text-transform:none;letter-spacing:0';
    const einsetzen = () => {
      if (a.isConnected) return;
      const pk = document.querySelector('variant-picker');
      const feld = pk && [...pk.querySelectorAll('fieldset')].find((f) => [...f.querySelectorAll('input[type="radio"]')].some((x) => gruppe(x.value)));
      const legende = feld && feld.querySelector('legend');
      if (legende) { legende.style.width = '100%'; legende.append(a); return; }
      if (pk) { a.style.float = 'none'; a.style.display = 'inline-block'; a.style.marginTop = '10px'; pk.after(a); }
    };
    einsetzen();
    new MutationObserver(einsetzen).observe(picker.parentElement, { childList: true, subtree: true });
  };
  if (document.querySelector('variant-picker') || location.pathname.includes('/products/')) {
    customElements.whenDefined('variant-picker').then(() => setTimeout(() => { vorwaehlen(); finderLink(); }, 50));
  }
})();
